/**
 * @deprecated This component is deprecated and will be removed in a future release.
 * Please use the new Quimby UI component instead:
 *
 * Import: `import { CheckboxList } from '@ui/molecules/inputs';`
 *
 * Or specific path: `import { MultiSelect } from '@ui/molecules/inputs/MultiSelect';`
 *
 * See the new component for documentation and migration notes.
 */
import React from 'react';
import Checkbox from '@components/v2/Checkbox';
import './CheckboxListContainer.scss';
/* eslint-disable react/require-default-props */
export default function CheckboxList({ options, onChange, label, value, required = false, error = undefined }) {
    const onCheck = (valueChecked) => {
        onChange(valueChecked);
    };
    const onElementClick = (e, valueChecked) => {
        e.preventDefault();
        e.stopPropagation();
        onCheck(valueChecked);
    };
    return (React.createElement("div", { className: `checkboxListContainer ${error ? 'has-error' : ''}` },
        label && React.createElement("label", { className: `qmb-label ${required ? '--required' : ''}` }, label),
        React.createElement("ul", { key: "container" }, options.map((option) => (React.createElement("li", { key: option.value, onClick: (e) => {
                if (e.target.type !== 'checkbox') {
                    onElementClick(e, option.value);
                }
            } },
            React.createElement(Checkbox, { id: option.value.toString(), checked: value.includes(option.value), onChange: () => onCheck(option.value), onClick: (e) => e.stopPropagation(), label: option.title }))))),
        error && React.createElement("span", { className: "error-message" }, error)));
}
